import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

export const resourceRoutes = (): RouteConfig[] => [
  {
    path: '/resource-pack',
    exact: true,
    name: '购买资源包',
    component: lazy(() => import('@/presentation/pages/resource-pack')),
    hideInMenu: true,
  },
  {
    path: '/order',
    exact: true,
    name: '购买资源包',
    component: lazy(() => import('@/presentation/pages/resource-pack/order')),
    hideInMenu: true,
  },
];

export default resourceRoutes;
